export default function({$auth, route, redirect}) {
  let perArray = [
    {route: 'intern-anbaugeraete', permission: 'Anbaugeräte verwalten'},
    {route: 'intern-arbeitszeiten', permission: 'Arbeitszeiten verwalten'},
    {route: 'intern-betriebe', permission: 'Betriebe verwalten'},
    {route: 'intern-maschinen', permission: 'Maschinen verwalten'},
    {route: 'intern-rollen', permission: 'Nutzer verwalten'},
    {route: 'intern-tankungen', permission: 'Tankungen verwalten'},
    {route: 'intern-tankungen-abrechnungen', permission: 'Tankungen verwalten'},
    {route: 'intern-tankungen-abrechnungen-id', permission: 'Tankungen verwalten'},
    {route: 'intern-treibstofftanks', permission: 'Treibstofftanks verwalten'},
    {route: 'intern-reports', permission: 'Reports abrufen'},
  ]
  let perm = perArray.find(el => el.route == route.name)
  let neededPermission = (perm) ? perm.permission : '';

  if (!neededPermission) return true;
  let can = $auth.user.allePermissions.find(el => el.name == neededPermission);
  if (can) return true;
  console.log('Zugriff verweigert. Nicht die entsprechende Permission '+neededPermission);
  return redirect('/dashboard');

}
